import ProductsRootView from "./ProductsRootView";

import "./ProductsRootView.scss";

export { ProductsRootView };
